import React from "react";
import style from "./Button.module.scss";

export default function CustomButton({ text, onClick, endIcon }) {
  return (
    <div className={style.custom__button} onClick={onClick}>
      <button>
        <span>{text}</span> {endIcon}
      </button>
      <i className={style.shine}></i>
    </div>
  );
}
